module.exports = __webpack_public_path__ + "static/media/2.3cf8c285.jpg";